import React from 'react';

import styles from './progress-bar.pcss';

type Props = {
	percent: number;
	finished: boolean;

};

const ProgressBar = ( {percent, finished}: Props ) => {
	if ( percent > 99 && ! finished ) {
		percent = 99;
	}
	return (
		<div className={styles.wrap}>
			<div className={styles.fill} style={{width: `${percent}%`}}>
				<span className={styles.label}>
					{`${Math.min( percent, 100 )}%`}
				</span>
			</div>
		</div>
	);
};

export default ProgressBar;
